export default {
  CUSTOMER: "App\\Models\\Customer",
  POLICY: "App\\Models\\Policy",
  DAMAGE: "App\\Models\\Damage",
  MORTGAGE: "App\\Models\\Mortgage",
  MORTGAGE_PART: "App\\Models\\MortgagePart",
  OBLIGATION: "App\\Models\\Obligation",
  TASK: "App\\Models\\Task",
};
